import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { FETCHER_DROPDOWN_OPTIONS } from '../../../../shared/fetchers';
import useDispatchOnMount from '../../../hooks/useDispatchOnMount';
import * as PackageInventoryStore from '../../../redux/packageInventory';
import type { ThirdPartyFetcher } from '../../../../shared/fetchers';
import type { SelectOption } from '../../../types';

/**
 * Fetches the list of package managers in use once when the component mounts.
 * Then pulls the list from the state and puts any package managers the org actually uses
 * ahead of the ones it doesn't.
 */
const usePackageManagers = (): { isLoading: boolean; fetchers: Array<SelectOption<ThirdPartyFetcher>>; } => {
  const packageManagers = useSelector(PackageInventoryStore.selectors.getPackageManagersSorted);
  const { isLoading } = useSelector(PackageInventoryStore.selectors.getAsyncStatusGetPackageManagers);
  useDispatchOnMount(PackageInventoryStore.actions.fetchPackageManagers);

  const fetchers = useMemo(() => {
    if (!packageManagers.length) {
      return FETCHER_DROPDOWN_OPTIONS;
    }

    // @TODO: Ensure that the backend filters for both 'rpm' and 'rpm-generic' locators
    return FETCHER_DROPDOWN_OPTIONS.filter(({ value }) => packageManagers.includes(value));
  }, [packageManagers]);

  return {
    isLoading,
    fetchers,
  };
};

export default usePackageManagers;
